export default "__VITE_ASSET__Ca37yoMf__"